




















import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import { QPullToRefresh, QInfiniteScroll } from 'quasar'

@Component
export default class PullAndScroll extends Vue {
  ready = false

  @Prop({ default: false })
  readonly disable!: boolean

  @Prop()
  readonly target!: HTMLElement | string | undefined

  @Ref()
  readonly refresher!: QPullToRefresh

  @Ref()
  readonly loader!: QInfiniteScroll

  created () {
    this.$nextTick(() => {
      this.refresher.trigger()
    })
  }

  refresh (done: () => void) {
    this.ready = false
    this.loader.stop()
    this.$emit('refresh', () => {
      done()
      this.ready = true
      // this.loader.reset()
      this.loader.resume()
      this.loader.poll()
    })
  }

  load (index: number, done: (stop?: boolean) => void) {
    this.$emit('load', index, (stop?: boolean) => {
      done(stop)
    })
  }
}
